import PaymentInformation from 'components/PaymentInformation'
import PaymentMethods from 'components/PaymentMethods'

export default {
  components: {
    PaymentInformation,
    PaymentMethods
  },

  data () {
    return {
      isLoading: true,
      taskIsActive: false,
      paymentMethodCode: null,
      paymentMethodName: null,
      paymentForm: null
    }
  },

  methods: {
    setPaymentMethod (paymentMethod) {
      this.paymentMethodCode = paymentMethod.code
      this.paymentMethodName = paymentMethod.name
    }
  },

  watch: {
    paymentForm (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          let paymentForm = this.$refs.paymentForm.querySelector('#payment-form')
          let paymentType = paymentForm.getAttribute('name') || null
          if (paymentType === 'Worldpay' || paymentType === 'PayPal') {
            window.location.href = paymentForm.action
          } else {
            paymentForm.submit()
          }
        })
      }
    }
  }
}
